import React from "react";
interface PlainteProps {
  color?: string;
}
const Plainte: React.FC<PlainteProps> = ({ color = "#086D33" }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3.16666V7.16666C14 7.43187 14.1054 7.68623 14.2929 7.87376C14.4804 8.0613 14.7348 8.16666 15 8.16666H19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12.1667V5.16666C5 4.63622 5.21071 4.12752 5.58579 3.75244C5.96086 3.37737 6.46957 3.16666 7 3.16666H14L19 8.16666V12.1667M5 21.1667H19M5 18.1667H19M5 15.1667H19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Plainte;
